import AppRights from "../../services/AppRights";
import { _ROLES_ADMIN, _ROLES_BACK } from "../../utils/constants";
import { RequestHelper } from "../../utils/requestHelper";
import { useContext, useEffect, useState } from "react";
import { _ROUTES } from "../../utils/_routes_constants";
import { getDataGeneric } from "../../repository/DataGeneric";
import FormTitle from "../../components/helpers/FormTitle";
import { UserContext } from "../../contexts/UserContext";
import { Box, Tab, Tabs } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { buildOptions } from "../../utils/formHelper";
import { BasicFormikForm } from "../../components/form/BasicFormikForm";
import FormFilter from "../../components/budget/payroll/FormFilter";
import { ColumnBuilder } from "../../components/budget/payroll/ColumnBuilder";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import TablePayroll from "../../components/budget/payroll/TablePayroll";
import { ExcelExportModule } from "ag-grid-enterprise";
import NoDataAvailableInput from "../../components/budget/NoDataAvailableInput";
import {
  _SAVE_CATEGORY_PAYROLL,
  _SAVE_DATA_PAYROLL,
} from "../../utils/constantsSave";
import { BaseBudgetSave } from "../../components/budget/BaseBudgetSave";
import { sendToFinancialData } from "../../components/budget/BaseBudgetSaveFunctions";
import { createToast } from "../../utils/toast";

ModuleRegistry.registerModules([AllCommunityModule, ExcelExportModule]);

const InputPayrolls = () => {
  const [budgetParameters, setBudgetParameters] = useState([]);
  const [rows, setRows] = useState([]);
  const [params, setParams] = useState({});
  const [columns] = useState(
    ColumnBuilder({ budgetParameters: budgetParameters?.[0] }),
  );
  const [options, setOptions] = useState({
    site: [],
    activity: [],
  });
  const [tab, setTab] = useState(0);
  const [saveData, setSaveData] = useState([]);
  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };
  const roles = _ROLES_ADMIN;
  const data = _SAVE_DATA_PAYROLL;
  const save_name_category = _SAVE_CATEGORY_PAYROLL;

  const rq = new RequestHelper();
  const { user } = useContext(UserContext);
  const isUserPayrollAllowed =
    user?.roles?.includes(_ROLES_BACK._ROLE_PAYROLL) &&
    budgetParameters?.[0]?.dataEntryEnablePayroll;

  /**
   *Sauvegarde des données à envoyer au back pour les financials data
   */
  useEffect(() => {
    if (saveData.length > 0) {
      /** modify data for back refactoring */
      const modifiedData = saveData.map((d) => {
        return {
          ...d,
          activityId: formik.values.activity,
          siteId: formik.values.site,
          theme: d.rowName,
          months: {
            1: d["1"],
            2: d["2"],
            3: d["3"],
            4: d["4"],
            5: d["5"],
            6: d["6"],
            7: d["7"],
            8: d["8"],
            9: d["9"],
            10: d["10"],
            11: d["11"],
            12: d["12"],
          },
        };
      });
      sendToFinancialData(modifiedData, save_name_category);
    } else {
      createToast("error", "Select the data table to save");
    }
  }, [saveData]);

  /*SELECT OPTS*/
  useEffect(() => {
    if (budgetParameters.length === 0) {
      getDataGeneric(
        rq,
        {},
        (d) => {
          setBudgetParameters(d);
          if (d && d.length > 0) {
            setParams((prevParams) => ({
              ...prevParams,
              fiscalYear: d[0].dataEntryFiscalYearDate,
              version: d[0].dataEntryFiscalYearVersion,
            }));
          }
        },
        _ROUTES.BUDGET_PARAMETERS,
        "Unable to retrieve budget parameters",
      );
    }

    if (options.site.length === 0) {
      getDataGeneric(
        rq,
        {
          pagination: false,
          active: 1,
          "order[name]": "ASC",
          "groups[]": "select:get",
        },
        (data) => {
          setOptions((prevOptions) => ({
            ...prevOptions,
            site: buildOptions(data, "name", "id"),
          }));
        },
        _ROUTES.SITES,
        "Unable to retrieve sites",
      );
    }

    if (options.activity.length === 0) {
      getDataGeneric(
        rq,
        {
          pagination: false,
          active: 1,
          "order[name]": "ASC",
          "groups[]": "select:get",
        },
        (data) => {
          setOptions((prevOptions) => ({
            ...prevOptions,
            activity: buildOptions(data, "name", "id"),
          }));
        },
        _ROUTES.ACTIVITIES,
        "Unable to retrieve activities",
      );
    }
  }, []);

  const v = Yup.object({
    site: Yup.string().required("Site is required").label("Site"),
    activity: Yup.string().required("Activity is required").label("Activity"),
  });

  const formik = useFormik({
    initialValues: {
      site: "",
      activity: "",
    },
    validationSchema: v,
    onSubmit: (values) => {
      setParams((prevParams) => ({
        ...prevParams,
        site: values.site,
        activity: values.activity,
      }));
    },
  });

  formik["special"] = {
    customStructure: {
      0: ["site", "activity"],
    },
    layout: {
      site: {
        selectWidth: "15%",
      },
      activity: {
        selectWidth: "15%",
      },
      lineDisposition: "start",
      childrens: (
        <FormFilter budgetParameters={budgetParameters} formik={formik} />
      ),
    },
  };

  // Effet séparé pour les activités qui dépendent du site
  useEffect(() => {
    // Ne charger les activités que si un site est sélectionné
    if (formik.values.site) {
      getDataGeneric(
        rq,
        {
          pagination: false,
          active: 1,
          "order[name]": "ASC",
          "groups[]": "select:get",
          site: formik.values.site,
        },
        (data) => {
          setOptions((prevOptions) => ({
            ...prevOptions,
            activity: buildOptions(data, "name", "id"),
          }));
        },
        _ROUTES.ACTIVITIES,
        "Unable to retrieve activities",
      );
    }
  }, [formik.values.site]);

  if (budgetParameters.length === 0) {
    return <NoDataAvailableInput />;
  }

  return (
    <>
      <AppRights
        roles={[
          _ROLES_BACK._ROLE_ADMIN,
          _ROLES_BACK._ROLE_CTRL,
          isUserPayrollAllowed ? _ROLES_BACK._ROLE_PAYROLL : null,
        ]}
      />
      <Box sx={{ width: "100%", typography: "body1" }}>
        <FormTitle title="Input Payrolls" />
        <Tabs value={tab} onChange={handleTabChange}>
          <Tab label="Input" />
          {roles.includes(user?.roles[0]) && <Tab label="Parameters" />}
        </Tabs>
        {tab === 0 && (
          <Box
            width={"100%"}
            p={2}
            sx={{
              backgroundColor: "white",
            }}
          >
            <BasicFormikForm
              formik={formik}
              validations={v}
              options={options}
            />
            <Box style={{ height: 500 }}>
              <TablePayroll
                rows={rows}
                columns={columns}
                setRows={setRows}
                params={params}
                saveData={saveData}
                setSaveData={setSaveData}
              />
            </Box>
          </Box>
        )}
        {tab === 1 && (
          <BaseBudgetSave arrayData={data} category={save_name_category} />
        )}
      </Box>
    </>
  );
};

export default InputPayrolls;
